import { AutogenLayoutFactoringPortal } from "./autogen/AutogenLayoutFactoringPortal";

export class FactoringPortal extends AutogenLayoutFactoringPortal {

  override onLoad() {

  }
}
